import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowsRotate,
  faCircleCheck,
  faCircleXmark,
  faClock,
  faPaperPlane,
  faPenToSquare,
  faTrash,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

export const chaseTableActions = [
  {
    name: "Edit Chase",
    icon: faPenToSquare,
  },
  {
    name: "Delete Chase",
    icon: faTrash,
  },
];

export const chaseHeadingData = [
  {
    header: "CUSTOMER NAME",
    accessor: "customerName",
  },
  {
    header: "CONTACT DETAILS",
    accessor: "contactDetails",
  },
  {
    header: "DATES",
    accessor: "type",
  },
  {
    header: "AMOUNT",
    accessor: "amount",
  },
  {
    header: "TYPE",
    accessor: "",
  },
  {
    header: "STATUS",
    accessor: "status",
  },
  {
    header: "",
    accessor: "types",
  },
  {
    header: "ACTIONS",
    accessor: "actions",
  },
];

export const branddata = [
  {
    name: "CCD",
    label: "Car Compare Direct",
  },
  {
    name: "CLD",
    label: "Car LineDirect",
  },
  {
    name: "VLD",
    label: "Van LineDirect",
  },
  {
    name: "VCD",
    label: "VanCompare Direct",
  },
  {
    name: "VI",
    label: "Van Insurance UK",
  },
  {
    name: "MYB",
    label: "Mind Your Business",
  },
];

export const brandCodes = [
  { value: "BICX", label: "VanInsurance.co.uk" },
  { value: "BIKI", label: "BikeInsurance.co.uk" },
  { value: "BCOM", label: "BikeCompareDirect" },
  { value: "BLD", label: "BikelineDirect" },
  { value: "BUSC", label: "BusinessCompare" },
  { value: "BACT", label: "BusinessCompare(Acturis)" },
  { value: "BOGI", label: "BusinessCompare(OGI)" },
  { value: "CARI", label: "CarInsurance.co.uk" },
  { value: "CCOM", label: "CarCompareDirect" },
  { value: "CCOT", label: "CarCompareDirect" },
  { value: "CLD", label: "CarlineDirect" },
  { value: "CLDT", label: "CarlineDirect" },
  { value: "CLDX", label: "CarlineDirect" },
  { value: "CRC", label: "CourierCompare" },
  { value: "CRCT", label: "CourierCompare" },
  { value: "CVAI", label: "VanInsurance.co.uk" },
  { value: "CVCT", label: "VanCompareDirect" },
  { value: "CVLT", label: "VanlineDirect" },
  { value: "HCOM", label: "HomeCompareDirect" },
  { value: "HLD", label: "HomelineDirect" },
  { value: "NCAR", label: "CarCompareDirect" },
  { value: "NCLD", label: "CarlineDirect" },
  { value: "NCOM", label: "VanCompareDirect" },
  { value: "NVAI", label: "VanInsurance.co.uk" },
  { value: "NVLD", label: "VanlineDirect" },
  { value: "SBIZ", label: "SimplyBusiness" },
  { value: "VANI", label: "VanInsurance.co.uk" },
  { value: "VANL", label: "VanInsurance.co.uk" },
  { value: "VANT", label: "VanInsurance.co.uk" },
  { value: "VCOL", label: "VanCompareDirect" },
  { value: "VCOM", label: "VanCompareDirect" },
  { value: "VCOT", label: "VanCompareDirect" },
  { value: "VICC", label: "VanInsurance.co.uk" },
  { value: "VICN", label: "VanInsurance.co.uk" },
  { value: "VICX", label: "VanInsurance.co.uk" },
  { value: "VLD", label: "VanlineDirect" },
  { value: "VLDC", label: "VanlineDirect" },
  { value: "VLDT", label: "VanlineDirect" },
  { value: "VLDV", label: "VanlineDirect" },
  { value: "VLDW", label: "VanlineDirect" },
  { value: "VLDX", label: "VanlineDirect" },
];

export type LoanStatusRow = {
  name: string;
  /** Tinted plate behind the status pill — a light tint, a dark /15 wash. */
  bgColor: string;
  icon: IconDefinition;
  /** Ink for both the pill icon and its label. */
  color: string;
};

export const loanStatusData: LoanStatusRow[] = [
  {
    name: "Inviting",
    bgColor: "bg-indigo-50 dark:bg-indigo-500/15",
    icon: faPaperPlane,
    color: "text-indigo-700 dark:text-indigo-300",
  },
  {
    name: "Auto-Renewals",
    bgColor: "bg-blue-50 dark:bg-blue-500/15",
    icon: faArrowsRotate,
    color: "text-blue-800 dark:text-blue-300",
  },
  {
    name: "Pending-Invite",
    bgColor: "bg-fuchsia-50 dark:bg-fuchsia-500/15",
    icon: faClock,
    color: "text-fuchsia-800 dark:text-fuchsia-300",
  },
  {
    name: "Renewed",
    bgColor: "bg-emerald-50 dark:bg-emerald-500/15",
    icon: faCircleCheck,
    color: "text-emerald-800 dark:text-emerald-300",
  },
  {
    name: "Failed",
    bgColor: "bg-rose-50 dark:bg-rose-500/15",
    icon: faCircleXmark,
    color: "text-rose-800 dark:text-rose-300",
  },
  {
    name: "Payment-Failed",
    bgColor: "bg-amber-50 dark:bg-amber-500/15",
    icon: faTriangleExclamation,
    color: "text-amber-800 dark:text-amber-300",
  },
];

/** Shown when a chase carries a status the table has no entry for. */
export const defaultLoanStatus: LoanStatusRow = {
  name: "Unknown",
  bgColor: "bg-overlay-mid",
  icon: faClock,
  color: "text-light-gray",
};
